import { render, staticRenderFns } from "./GapStatisticApplicability.vue?vue&type=template&id=36316878&scoped=true&"
import script from "./GapStatisticApplicability.vue?vue&type=script&lang=ts&"
export * from "./GapStatisticApplicability.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36316878",
  null
  
)

export default component.exports